import React, { useState, useEffect } from "react";
import Carousel from 'react-elastic-carousel';
import background from "./imge/background.png"
import footer from "./imge/footer.png"
export default function LandingPage() {

  const [meals, setMeals] = useState([
    { id: 1, title: "./imge/middle-1.png" },
    { id: 2, title: './imge/middle-2.png' },
    { id: 3, title: './imge/middle-3.png' },
    { id: 4, title: './imge/middle-4.png' },

  ])
  const [phones, setphones] = useState([
    { id: 1, title: "./imge/app1.png" },
    { id: 2, title: './imge/app2.png' },
    { id: 3, title: './imge/app3.png' },
    { id: 4, title: './imge/app4.png' },
    { id: 5, title: './imge/app5.png' },
    { id: 6, title: './imge/app6.png' },

  ])
  function urlTo(type) {
    if (type == "ios") {
      window.location = "https://apps.apple.com/us/app/protein/id1473589285";
    } else if ("android") {
      window.location =
        "https://play.google.com/store/apps/details?id=com.protein_app_1c410.firebaseapp.base";


    } else { return; }

  }

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

      }}
    >
      <img src={require("./imge/header.png")} width={"100%"} />
      <div style={{ width: "100%", marginTop: -20 }}>
        <img src={require('./imge/middle.png')} width={"100%"} />

      </div>
      <div style={{ width: "100%", backgroundImage: `url(${background})`, position: "relative", marginTop: -10,  }}>

        <Carousel
        isRTL={true}
          itemsToShow={1}
          pagination={false}
          showArrows={false}>
          {phones.map(item => <div key={item.id}> <img src={require(`${item.title}`)} width={"100%"} /> </div>)}
        </Carousel>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", position: "absolute", top: 148, left: "57%", color: "whitesmoke", fontSize: 14, }}>


          {/* <span > حمل التطبيق</span> */}



        </div>

        {/* <div style={{  
       display: "flex",  
        flexDirection: "row",
        alignItems: "center",
        position:"absolute" ,top:170,right:"12%"  ,color:"whitesmoke"
        }}>
      <img src={require("./imge/google.png")}width={70}/>
      <img src={require("./imge/apple.png")}width={70}/>

      </div> */}
        <div style={{ position: "relative", marginTop:-50 }}>
          <img src={require("./imge/footer.png")} width={"100%"} height={130} />

          <div style={{
            display: "flex",
            flexDirection: 'row-reverse',

            alignItems: "center",
            justifyContent: "space-between",
            position: "absolute"
            , top: 40,
            width:"100%" ,
          }}>
            <div style={{ color: "#b1d136", fontSize: 14, marginRight: 5, display: "flex", flexDirection: "column", paddingLeft: 10, justifyContent: "flex-start" ,width:"40%" , }}>
              <span style={{ marginRight: 30 }} > تواصل معنا</span>
              <div style={{
                display: "flex",
                flexDirection: "row",
               



              }}>

                <img onClick={() => window.location = "https://api.whatsapp.com/send?phone=966533835233"} src={require("./imge/whats.png")} width={40} height={35} />
                <img onClick={() => window.location = "https://twitter.com/protein_40/status/1342462246102949890?s=21"} src={require("./imge/twitter.png")} width={40} height={35} />
                <img onClick={() => window.location = "https://instagram.com/protein_40?igshid=1kcodp7qxgap2"} src={require("./imge/insta.png")} width={40}  height={35}/>
              </div>
            </div>
            <div style={{ color: "#b1d136", fontSize: 14, marginRight: 5,  paddingLeft: 10   ,
                width:"60%" }}>
              <span style={{marginRight:10}} >  اضغط لتحميل التطبيق</span>


              <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginRight: 5
                ,
                width:"100%"
              }} >
                <img onClick={() => urlTo("android")} src={require("./imge/google.png")} width={"50%"} />
                <img onClick={() => urlTo("ios")} src={require("./imge/apple.png")} width={"50%"} />
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}
